// Story 213 (contrato-sun.md §2): Sun serves the protected mark (`sensitive`, `sensitiveInherited`, `sensitiveVia`) on each
// entry of `groups[].entries[]`, not inside its `document`. The lock of the row and the boundary of the viewer read it from
// the document they get, so the entry's mark travels with it. Without those fields (vision off) the document is as today.
const MARK_FIELDS = ['sensitive', 'sensitiveInherited', 'sensitiveVia']

const documentOfEntry = (entry) => MARK_FIELDS
  .filter((field) => field in entry)
  .reduce((document, field) => ({ ...document, [field]: entry[field] }), { ...(entry.document || {}) })

export default documentOfEntry
